import gql from 'graphql-tag';

import { clients } from '../../../util/clients';
import { getFYList } from '../../../util/shared/tmc-global';
import { bidderRegistration } from './bidderRegistration.action';
import { juneResaleActions } from './juneResale.action';

const { backend } = clients.direct;

export const juneResale = {
  namespaced: true,
  state: () => ({
    isDialog: false,
    saleYearList: [],
    latestSaleYear: 0,
  }),
  mutations: {
    setDialog(state, isDialog) {
      state.isDialog = isDialog;
    },
    setLatestSaleYear(state, list) {
      state.latestSaleYear = list;
    },
    setSaleYearList(state, list) {
      state.saleYearList = list;
    },
  },
  getters: {
    getDialog(state) {
      return state.isDialog;
    },

  },
  actions: {
    ...bidderRegistration,
    ...juneResaleActions,
    async loadSaleYearList({ commit, dispatch }, { postProcessTrans, allowAll = true }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`{
                juneResaleStatsRange { max, min }
              }`,
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { juneResaleStatsRange } = results.data;
          const resaleList = getFYList(juneResaleStatsRange, allowAll);
          if (resaleList.length > 0) {
            const [highestYear] = resaleList.sort((a, b) => b - a);
            commit('setLatestSaleYear', highestYear);
          }
          const processedTransData = postProcessTrans
            ? postProcessTrans(resaleList) : resaleList;
          commit('setSaleYearList', processedTransData);

          return processedTransData;
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting min/max date ranges.', { root: true });
      }
      return {};
    },
  },
};

export default juneResale;
